import { isBrowser, isServiceWorker } from '../device-type';

export let appShellTemplateUrl = '/appshell/template';
export const hasServiceWorker = isBrowser() && !isServiceWorker() && WITH_SERVICEWORKER && 'serviceWorker' in navigator;

export function clearCache(): Promise<boolean> {
  if (!hasServiceWorker || !self.caches) {
    return Promise.resolve(true);
  }
  return caches
    .keys()
    .then((cacheNames: string[]) => Promise.all(cacheNames.map(cacheName => caches.open(cacheName))))
    .then((caches: Cache[]) => {
      // It might seem odd that `clearCache` only clears the app shell template
      // but the app shell template is the only entry in the cache that is mutable.
      // If any of the other entries change they will get new urls and a new app shell template
      // will point to the new resources instead.
      // Old entries will eventually get cleaned up by the logic in `onInstall`.
      return Promise.all(caches.map(cache => cache.delete(new Request(appShellTemplateUrl))));
    })
    .then(deletes => deletes.every(d => d));
}
